// extracted by mini-css-extract-plugin
export default {"products":"mz-z","card":"nz-z","oosMessaging":"oz-z"};